import { entity } from "./Connection"

// ShipUser (crew) has no per-ship list endpoint of its own: the roster rides the
// `ships.get` bundle (`IShipResponse.users`), so a ShipUser query delegates to
// Ship's fetch via `providedBy` — the same way Status rides the Log bundle. Live
// token (`Subscription.ShipUser`), owner-FK indexes and the `deletedAt`
// soft-delete are auto-derived by `entity()`.
export const ShipUserEntity = entity("ShipUser", { providedBy: "Ship" });
